export const DEFAULT_PASSKEY_DISPLAY_NAME = 'Train user';
/** In-memory fallback storage (non-persistent). */
export class InMemoryPasskeyStorage {
    constructor() {
        this.credentials = [];
        this.activeId = null;
    }
    getActiveCredentialId() { return this.activeId; }
    getAllCredentials() { return this.credentials.map(c => ({ ...c })); }
    getAllCredentialIds() { return this.credentials.map(c => c.id); }
    storeCredentialId(credId, label) {
        const trimmed = label?.trim();
        const existing = this.credentials.find(c => c.id === credId);
        if (existing) {
            if (trimmed)
                existing.label = trimmed;
        }
        else {
            this.credentials.push({ id: credId, label: trimmed || DEFAULT_PASSKEY_DISPLAY_NAME });
        }
        this.activeId = credId;
    }
    removeCredentialId(credId) {
        this.credentials = this.credentials.filter(c => c.id !== credId);
        if (this.activeId === credId) {
            this.activeId = this.credentials[0]?.id ?? null;
        }
    }
    clearAllCredentials() {
        this.credentials = [];
        this.activeId = null;
    }
}
